export enum DeviceType {
  iOS = 'iOS',
  Android = 'Android',
}
